import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OurHostsService } from './our-hosts.service';

@Component({
    selector: 'app-our-hosts',
    templateUrl: './our-hosts.component.html',
    styleUrls: ['./our-hosts.component.scss']
})
export class OurHostsComponent implements OnInit {

	public data: any;
	public data2: any;

    constructor(
		private content: OurHostsService,
        public router: Router
    ) {
        
        this.content.getData2().subscribe((data: any) => {
            this.data = data.data;
        });
    }

    ngOnInit(): void {
    }

}